export const PermitTranslations = {
	email: "email", //Email
	password: "password", //Password
	phoneNumber: "phone-number", //Phone Number
	cancel: "cancel", //Cancel
	edit: "edit", //Edit
	back: "back", //Back
	next: "next", //Next
	sign_in: "sign-in", //Sign in
	sign_up: "sign-up", //Sign up
	send: "send", //Send
	log_out: "log-out", //Log out
	given_name: "given-name", //First name
	family_mame: "family-name", //Last name
	save_changes: "save-changes", //Save changes
	permit_type: "permit-type", //Permit Type
	invoice_id: "invoice-id", //Invoice Id
	date: "date", //Date
	driver: "driver", //Driver
	residency: "residency", //Residency
	vehicles: "vehicles", //Vehicles
	start_date: "start-date", //Start date
	start_time: "start-time", //Start time
	end_date: "end-date", //End date
	end_time: "end-time", //End time
	days_of_week: "days-of-week", //Days of the week
	zone: "zone", //Zone
	tariff: "tariff", //Permit type
	address: "address", //Address
	view: "view", //View
	view_all: "view-all", //View all
	apply: "apply", //Apply
	done: "done", //Done
	amount: "amount", //Amount:
	fee: "fee", //Service fee:
	price: "price", //Price:
	wallet: "wallet", //Wallet:
	pay: "pay", //Pay {total}
	preview: "preview", //Preview
	download: "download", //Download
	upload: "upload", //Upload
	repeat: "repeat", //Repeat
	add_new: "add-new", //Add new
	change_in_progress: "change-in-progress",
	visitor_pass:"visitor-pass",//Visitor pass
	add_visitor_pass:"add-visitor-pass",//Add visitor pass
	add_visitor_pass__invalid:"add-visitor-pass--invalid",//Permit must be approved before you can add a visitor pass
	send_for_review:"send-for-review",//Send for review
	number_of_months:"number-of-months",
	number_of_months_placeholder:"number-of-months-placeholder",
	confirm_payment:"confirm-payment",
	confirm_payment__final:"confirm-payment__final",
	confirm_payment__confirm:"confirm-payment--confirm",
	confirm_payment__cancel:"confirm-payment--cancel",

	entity_type:"entity-type",//Belongs to
	entity_information:"entity-information",//Belongs to
	document_type:"document-type",//Document type
	expiration_date:"expiration-date",//Expiration date
	document_status:"document-status",//Status

	recurrence__recurrency:"recurrence__recurrency",//Recurrency
	recurrence__recurrency__desc:"recurrence__recurrency--desc",//Select the dates and times you want to repeat this event.
	recurrence__range:"recurrence__range",//Range
	recurrence__range__desc:"recurrence__range--desc",//Choose the period during which this visitor pass should be active.
	recurrence__repeat:"recurrence__repeat",//Repeat
	recurrence__date__start:"recurrence__date--start",//Period start date
	recurrence__date__end:"recurrence__date--end",//Period end date
	recurrence__type__none:"recurrence__type--none",//None
	recurrence__type__daily:"recurrence__type--daily",//Daily
	recurrence__type__weekly:"recurrence__type--weekly",//Weekly
	recurrence__type__monthly:"recurrence__type--monthly",//Monthly
	recurrence__type__yearly:"recurrence__type--yearly",//Yearly
	recurrence__notes:"recurrence__notes",//Recurrent permit on {days}

	entity__type__holder:"entity__type--holder",//Holder
	entity__type__permit:"entity__type--permit",//Permit
	entity__type__residency:"entity__type--residency",//Residency
	entity__type__driver:"entity__type--driver",//Driver
	entity__type__vehicle:"entity__type--vehicle",//Vehicle

	modify_address: "modify-address", //Modify address
	modify_vehicle: "modify-vehicle", //Modify vehicle

	website__application_loading: "website__application-loading", //Loading application configuration...
	website__terms_and_conditions: "website__terms-and-conditions", //By tapping "Sign up" or "Sign in" you agree to our Conditions of Use.  Learn how we process your data in our Privacy Policy and Cookies Policy.

	menu__new: "menu__new", //New
	menu__my_parking: "menu__my-parking", //My Parking
	menu__payments: "menu__payments", //Payments
	menu__vehicles: "menu__vehicles", //Vehicles
	menu__documents: "menu__documents", //Documents
	menu__invoices: "menu__invoices", //Invoices
	menu__settings: "menu__settings", //Settings

	welcome_page__title: "welcome-page__title", //Welcome to the Pittsburgh Parking Application Portal
	welcome_page__body: "welcome-page__body", //From this web portal, residents and non-residents are able to apply for, pay for, and manage their residential and non-residential parking permits without any need to come downtown or mail in documents. We still process applications via mail for residents who do not use email and at our walk-in counter.\n\nThe cost of the Residential Parking Permit is $20.00 per vehicle per program year and is not prorated for mid-year purchases. The cost to purchase an annual Visitor Parking Pass is $1.00 per address and is not prorated. There is a $2.50 processing fee for credit card purchases.\n\nPERMITS DO NOT EXPIRE ONE YEAR FROM PURCHASE DATE; EACH PERMIT AREA HAS ITS OWN EXPIRATION MONTH BY PROGRAM YEAR, NOT CALENDAR YEAR.
	welcome_page__or: "welcome-page__or", //Or
	features__portal_unavailable: "features__portal-unavailable",

	sign_in_page__forgot_password: "sign-in-page__forgot-password", //Forgot your password?

	sign_up_page__mandatory_password: "sign-up-page__mandatory-password", //Password is mandatory to create an account
	sign_up_page__already_have_account: "sign-up-page__already-have-account", //Already have an account?
	sign_up_page__log_into_account: "sign-up-page__log-into-account", //Log into Account
	sign_up_page__email_duplicated__title: "sign-up-page__email-duplicated--title", //A Blinkay account already exists with this email address.
	sign_up_page__email_duplicated__body: "sign-up-page__email-duplicated--body", //Please click "Sign in" if you remember your password, or click "Change password" if you need to reset it.
	sign_up_page__change_password: "sign-up-page__change-password", //

	forgot_password_page__forget_your_password: "forgot-password-page__forget-your-password", //Forget your password?
	forgot_password_page__instructions: "forgot-password-page__instructions", //We will email you instructions on how to create a new password
	forgot_password_page__email_sent: "forgot-password-page__email-sent", //You're almost there!
	forgot_password_page__email_sent__body: "forgot-password-page__email-sent--body", //We've sent a password-reset link to your email address. Please check your inbox and click the link to create a new password.

	new_permits_page__title: "new-permits-page__title", //Pittsburgh Parking Portal

	new_permit_page__title: "new-permit-page__title", //New permit
	new_permit_page__permit_type: "new-permit-page__permit-type", //Permit type
	new_permit_page__holder_type: "new-permit-page__holder-type", //Individual or Business
	new_permit_page__holder_type__hint: "new-permit-page__holder-type--hint", //Individual or Business
	new_permit_page__business: "new-permit-page__business", //Business data
	new_permit_page__business__hint: "new-permit-page__business--hint",
	new_permit_page__business__name: "new-permit-page__business__name",//Business Name
	new_permit_page__business__taxId: "new-permit-page__business__tax-id",
	new_permit_page__zone: "new-permit-page__zone", //Zone
	new_permit_page__find_address: "new-permit-page__find-address", //Please find a valid address
	new_permit_page__find_address__missing: "new-permit-page__find-address--missing", //No valid data was found on our system for that address
	new_permit_page__find_address__missing_body: "new-permit-page__find-address--missing-body", //No valid data was found on our system for that address
	new_permit_page__find_address__invalid: "new-permit-page__find-address--invalid", //Please find a valid address
	new_permit_page__find_address__invalid_body: "new-permit-page__find-address--invalid-body", //Please find a valid address
	new_permit_page__residency: "new-permit-page__residency", //Residency
	new_permit_page__residency__hint: "new-permit-page__residency--hint",
	new_permit_page__driver: "new-permit-page__driver", //Driver
	new_permit_page__driver__hint: "new-permit-page__driver--hint",
	new_permit_page__vehicle: "new-permit-page__vehicle", //Vehicle
	new_permit_page__vehicle__hint: "new-permit-page__vehicle--hint",
	new_permit_page__vehicle__selection_text: "new-permit-page__vehicle--selection-text",
	new_permit_page__vehicle__selection_help: "new-permit-page__vehicle--selection-help",
	new_permit_page__review_application: "new-permit-page__review-application", //Review application
	new_permit_page__review_application__expiration: "new-permit-page__review-application--expiration",

	permit_page__qr_code_text: "permit-page__qr-code-text",

	summary_page__title: "summary-page__title", //My parking
	summary_page__add_new_permit: "summary-page__add-new-permit", //Add new permit
	summary_page__cancel_permit: "summary-page__cancel-permit", //Cancel permit
	summary_page__cancel_permits: "summary-page__cancel-permits", //Cancel all permits
	summary_page__cancel_permit__alert: "summary-page__cancel-permit--alert", //Once you cancel the permit, {total} will be refunded and placed back into your wallet. Do you want to continue?
	summary_page__cancel_permits__alert: "summary-page__cancel-permits--alert", //Cancel all permits
	summary_page__active: "summary-page__active", //Active
	summary_page__archived: "summary-page__archived", //Archived
	summary_page__no_permits: "summary-page__no-permits", //No permits found
	summary_page__filters: "summary-page__filters", //Filters
	summary_page__filters__status_label: "summary-page__filters__status-label", //Status
	summary_page__filters__status_title: "summary-page__filters__status-title", //Filter by status
	summary_page__filters__plate_label: "summary-page__filters__plate-label", //Plate
	summary_page__filters__plate_title: "summary-page__filters__plate-title", //Filter by plate
	summary_page__filters__tariff_label: "summary-page__filters__tariff-label", //Permit type
	summary_page__filters__tariff_title: "summary-page__filters__tariff-title", //Filter by permit type
	summary_page__filters__tariff_placeholder: "summary-page__filters__tariff-placeholder", //Please select a permit type

	payments_page__title: "payments-page__title", //Payments
	payments_page__no_card: "payments-page__no-card", //No credit card on file, please add one
	payments_page__add_new_card: "payments-page__add-new-card", //Add a new card
	payments_page__change_card: "payments-page__change-card", //Change card
	payments_page__popup_error__title: "payments-page__popup-error--title", //Unable to open a new window for the payment authorization process
	payments_page__popup_error__description: "payments-page__popup-error--description", //This may be due to pop-up blocking. Please check your browser settings or extensions to ensure pop-ups are allowed for this site and try again.
	payments_page__popup_error__footer: "payments-page__popup-error--footer", //Thank you!
	payments_page__authorization_error__title: "payments-page__authorization-error--title", //We're sorry: we encountered an issue while processing your payment authorization
	payments_page__authorization_error__description: "payments-page__authorization-error--description", //Our team has been notified, and we recommend checking your payment details or trying again shortly. If the issue persists, please contact our support team for assistance.
	payments_page__authorization_error__footer: "payments-page__authorization-error--footer", //Thank you for your patience!
	payments_page__close_window__title: "payments-page__close-window--title", //Unable to open a new window for the payment authorization process
	payments_page__close_window__description: "payments-page__close-window--description", //This may be due to pop-up blocking. Please check your browser settings or extensions to ensure pop-ups are allowed for this site and try again.
	payments_page__close_window__footer: "payments-page__close-window--footer", //Thank you!

	invoices_page__title: "invoices-page__title", //Invoices

	settings_page__title: "settings-page__title", //Settings
	settings_page__change_password: "settings-page__change-password", //Change password
	settings_page__old_password: "settings-page__old-password", //Old password

	form_error__title: "form-error__title", //Something went wrong

	create_permit__upload_files: "create-permit__upload-files",
	create_permit__create_permit: "create-permit__create-permit",

	documents_page__title: "documents-page__title", //Documents
	documents_page__filters: "documents-page__filters", //Filters
	documents_page__filters__document_type_label: "documents-page__filters__document-type-label", //Type
	documents_page__filters__document_type_title: "documents-page__filters__document-type-title", //Filter by document type
	documents_page__filters__document_type_placeholder: "documents-page__filters__document-type-placeholder", //All document types
	documents_page__filters__category_label: "documents-page__filters__category-label", //Category
	documents_page__filters__category_title: "documents-page__filters__category-title", //Filter by category
	documents_page__filters__category_placeholder: "documents-page__filters__category-placeholder", //All categories
	documents_page__filters__status_label: "documents-page__filters__status-label", //Status
	documents_page__filters__status_title: "documents-page__filters__status-title", //Filter by status

	documentation: "documentation", //Documentation
	documentation__status: "documentation__status", //Status:
	documentation__reason: "documentation__reason", //Reason:
	documentation__expires: "documentation__expires", //Expires:
	documentation__comments: "documentation__comments", //Comments:
	documentation__required: "documentation__required", //Required documentation
	documentation__additional: "documentation__additional", //Additional documentation
	documentation__update: "documentation__update", //Documentation to update
	documentation__update__action: "documentation__update--action", //Update documentation
	documentation__expired: "documentation__expired", //Expired/rejected documentation
	documentation_page__title: "documentation-page__title", //Update documentation
	documentation__update__button: "documentation__update--button", //Update documentation
	documentation__updated: "documentation__updated", //All documents have been updated

	driver__full_name: "driver__full-name", //Driver full name
	driver__license_number: "driver__license-number", //License number

	new_driver__choose: "new-driver__choose", //Choose a driver
	new_driver__full_name: "new-driver__full-name", //Last name
	new_driver__license_number: "new_driver__license-number", //License number

	residency__street_number: "residency__street-number", //Street number
	residency__street: "residency__street", //Street
	residency__unit: "residency__apt-unit", //Apartment/Unit
	residency__suffix: "residency__suffix", //Suffix
	residency__postal_code: "residency__postal-code", //Postal code
	residency__city: "residency__city", //City
	residency__state: "residency__state", //State

	new_residency__street_number: "new-residency__street-number", //Street number
	new_residency__street: "new-residency__street", //Street
	new_residency__apt_unit: "new-residency__apt-unit", //Apt/Unit (Only the number or letter, NO special characters)
	new_residency__suffix: "new-residency__suffix", //Suffix
	new_residency__postal_code: "new-residency__postal-code", //Postal code
	new_residency__city: "new-residency__city", //City
	new_residency__state: "new-residency__state", //State
	new_residency__choose: "new-residency__choose", //Choose a residency

	vehicle__plate: "vehicle__plate", //License plate
	vehicle__nickname: "vehicle__nickname", //Nickname
	vehicle__type: "vehicle__type", //Year
	vehicle__color: "vehicle__color", //Color
	vehicle__color__placeholder: "vehicle__color__placeholder", //Please select a color
	vehicle__model: "vehicle__model", //Make
	vehicle__model__placeholder: "vehicle__model__placeholder", //Please select a make
	vehicle__province: "vehicle__province", //State
	vehicle__province__placeholder: "vehicle__province__placeholder", //Please select a state

	new_vehicle__choose: "new-vehicle__choose", //Choose a vehicle
	new_vehicle__plate: "new-vehicle__plate", //License plate
	new_vehicle__nickname: "new-vehicle__nickname", //Nickname
	new_vehicle__color: "new-vehicle__color", //Color
	new_vehicle__model: "new-vehicle__model", //Make
	new_vehicle__type: "new-vehicle__type", //Year
	new_vehicle__province: "new-vehicle__province", //State

	vehicles_page__title__new: "vehicles-page__title--new", //New vehicle
	vehicles_page__title__edit: "vehicles-page__title--edit", //Edit vehicle
	vehicles_page__residents: "vehicles-page__residents", //Residents
	vehicles_page__visitors: "vehicles-page__visitors", //Visitors
	vehicles_page__no_vehicles: "vehicles-page__no-vehicles", //No vehicles found

	validation__generic__required: "validation__generic--required", //The {value} is required
	validation__generic__max_size: "validation__generic--max-size", //The maximum allowed size for documents is 10 mb
	validation__number_of_month__required: "validation__number-of-month--required", //The number of months is required

	validation__start_date__required: "validation__start-date--required", //The start date is required
	validation__start_time__required: "validation__start-time--required", //The start time is required
	validation__start_period__required: "validation__start-period--required", //The period start date is required
	validation__end_date__required: "validation__end-date--required", //The end date is required
	validation__end_time__required: "validation__end-time--required", //The end time is required
	validation__end_period__required: "validation__end-period--required", //The period end date is required

	validation__business__name__required: "validation__business__name--required", //The business name is required
	validation__business__tax_id__required: "validation__business__tax-id--required", //An ABN or ACN is required

	validation__driver__full_name__required: "validation__driver__full-name--required", //The driver's full name is required
	validation__driver__license_number__required: "validation__driver__license-number--required", //The license number is required

	validation__residency__street_number__required: "validation__residency__street-number--required", //The street number is required
	validation__residency__street__required: "validation__residency__street--required", //The street name is required
	validation__residency__apt_unit__required: "validation__residency__apt-unit--required", //The street name is required
	validation__residency__suffix__required: "validation__residency__suffix--required", //The street name is required
	validation__residency__postal_code__required: "validation__residency__postal-code--required", //The street name is required
	validation__residency__city__required: "validation__residency__city--required", //The street name is required
	validation__residency__state__required: "validation__residency__state--required", //The street name is required
	validation__residency__zone__required: "validation__residency__zone--required", //The zone is required

	validation__vehicle__plate__required: "validation__vehicle__plate--required", //The vehicle plate is required
	validation__vehicle__plate__max_length: "validation__vehicle__plate--max-length", //The maximum plate length is {value}
	validation__vehicle__plate__duplicated: "validation__vehicle__plate--duplicated", //
	validation__vehicle__nickname__required: "validation__vehicle__nickname--required",
	validation__vehicle__color__required: "validation__vehicle__color--required",
	validation__vehicle__model__required: "validation__vehicle__model--required",
	validation__vehicle__type__required: "validation__vehicle__type--required",
	validation__vehicle__province__required: "validation__vehicle__province--required", //The state is required

	validation__email__required: "validation__email--required", //Email is required
	validation__email__invalid: "validation__email--invalid", //Email is invalid
	validation__password__required: "validation__password--required", //Password is required
	validation__password_rules: "validation__password-rules", //Password must contain:
	validation__password_rules__01_text: "validation__password-rules--01-text", //10 or more characters
	validation__password_rules__02_text: "validation__password-rules--02-text", //mixture of uppercase and lowercase
	validation__password_rules__03_text: "validation__password-rules--03-text", //letters and numbers
	validation__password_rules__04_text: "validation__password-rules--04-text", //one special character, e.g., ! @ # ?
	validation__password_rules__01_requirement: "validation__password-rules--01-requirement", //Password must be 10 or more characters
	validation__password_rules__02_requirement: "validation__password-rules--02-requirement", //Password must contain a mixture of uppercase and lowercase
	validation__password_rules__03_requirement: "validation__password-rules--03-requirement", //Password must contain letters and numbers
	validation__password_rules__04_requirement: "validation__password-rules--04-requirement", //Password must contain one special character, e.g., ! @ # ?
	validation__old_password__required: "validation__old-password--required", //Old password is required
	validation__given_name__required: "validation__given-name--required", //The first name is required
	validation__family_name__required: "validation__family-name--required", //The last name is required
	validation__phone__required: "validation__phone--required", //The phone number is required
	validation__phone__invalid: "validation__phone--invalid" //Phone number is invalid
} as const;
